import { createAndPublishAlbumRequest } from 'reactApp/modules/albums/albums.actions';
import { store as reduxStore } from 'reactApp/store';

import { getSelectedItems } from './helpers/getSelectedItems';

export const createAndPublishAlbum = () => {
    const state = reduxStore.getState();
    const items = getSelectedItems(state);

    reduxStore.dispatch(createAndPublishAlbumRequest({ items }));
};
